import React from 'react';
import {useStore} from "zustand";
import DebounceSelect from './DebounceSelect';
import memberAPI from "../../../api/memberAPI";
import {useMessageStore} from "../../../stores/messageStore";

export interface MemberValue {
	key: string;
	label: string;
	value: string;
	nickname: string;
	groupId: string;
	groupName: string;
}

export const emptyMemberValue: MemberValue = {
	key: '',
	label: '',
	value: '',
	nickname: '',
	groupId: '',
	groupName: '',
}

interface UserSearchSelectProps {
	placeholder?: string;
	onChange: (value: MemberValue) => void;
	selectedMember: MemberValue;
	selectedGroupId?: string;
	allowClear?: boolean;
	onClear?: () => any;
}

export const MemberSearchSelect: React.FC<UserSearchSelectProps> = ({
	                                                                    placeholder,
	                                                                    onChange,
	                                                                    selectedMember,
	                                                                    selectedGroupId,
	                                                                    allowClear,
	                                                                    onClear
                                                                    }: UserSearchSelectProps) => {
	const {setMessages} = useStore(useMessageStore);
	const fetchMemberList = async (nickname: string) => {
		if (!nickname) return [];

		try {

			const res = await memberAPI.memberSearchByNicknameAndGroupIdAPI(nickname, selectedGroupId);
			if (!res || res.length === 0) return [];

			const members = res.map((item: any) => ({
				key: item.id,
				label: `${item.nickname}`,
				value: item.id,
				nickname: item.nickname,
				groupId: item.groupId,
				groupName: item.groupName,
			})) as MemberValue[];

			return selectedGroupId
				? members.filter(member => member.groupId === selectedGroupId)
				: members;
		} catch (e) {
			console.error(e);
			setMessages('error', 'fetch member list error. please try again.');
			return [];
		}
	}

	return (
		<DebounceSelect
			key={selectedGroupId}
			value={selectedMember.key ? selectedMember : undefined}
			placeholder={placeholder}
			fetchOptions={fetchMemberList}
			onChange={(newValue) => onChange(newValue as MemberValue)}
			style={{width: '100%'}}
			allowClear={allowClear}
			onClear={onClear}
			optionRender={(option) => {
				return (
					<div style={{
						display: 'flex',
						justifyContent: 'space-between',
						width: '100%'
					}}>
						<span>{option.data.nickname}</span>
						<span>{option.data.groupName}</span>
					</div>
				)
			}}
		/>
	);
};

